import { useBalance, useAccount } from 'wagmi'
import { formatEther } from 'viem'

// Utility function to format numbers with commas
const formatTokenAmount = (amount: bigint): string => {
  const formatted = formatEther(amount);
  const [whole, decimal] = formatted.split('.');
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimal ? `${withCommas}.${decimal}` : withCommas;
};

interface TokenBalanceProps {
  tokenAddress: `0x${string}`
  symbol?: string
  className?: string
}

export function TokenBalance({ tokenAddress, symbol, className = '' }: TokenBalanceProps) {
  const { address } = useAccount()
  const { data: balance, isLoading } = useBalance({
    address,
    token: tokenAddress,
    watch: true,
  })

  if (!address) return null
  if (isLoading) return (
    <div className={`text-sm text-white/60 font-mono ${className}`}>
      Loading...
    </div>
  )
  if (!balance) return null

  return (
    <div className={`text-sm text-secondary font-mono ${className}`}>
      {formatTokenAmount(balance.value)} {symbol}
    </div>
  )
} 